"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hasScrollbar = _interopRequireDefault(require("@utils/hasScrollbar"));

var _getDataProps = _interopRequireDefault(require("@utils/getDataProps"));

var _scss = require("@scss");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["children", "isFluid", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

if ((0, _hasScrollbar["default"])() && typeof window !== 'undefined' && window.document) {
  window.document.body.dataset.scrollbar = 'true';
}

var Container = function Container(_ref) {
  var children = _ref.children,
      _ref$isFluid = _ref.isFluid,
      isFluid = _ref$isFluid === void 0 ? false : _ref$isFluid,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, (0, _getDataProps["default"])(props), {
    className: (0, _scss.cls)(className, isFluid ? _stylesModule["default"]['container-fluid'] : _stylesModule["default"]['container'])
  }), children);
};

var _default = Container;
exports["default"] = _default;